import React from 'react';
import { Button, Section, Card } from './Shared';
export const Hero = () => {
  return <>
      {/* Top Bar */}
      <div className="bg-dark text-base text-center py-3 px-4 font-montserrat text-sm font-medium tracking-wide" data-id="element-88">
        💅 BÓVEDA DIGITAL™ — Herramientas reales para emprendedoras reales
      </div>

      {/* Hero Section */}
      <Section bg="base" className="pt-12 md:pt-20" data-id="element-89">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-8" data-id="element-90">
          <div className="flex-1 text-center lg:text-left" data-id="element-91">
            <h1 className="font-playfair text-5xl md:text-6xl lg:text-7xl font-bold leading-tight mb-6 text-dark" data-id="element-92">
              Más clientas.
              <br data-id="element-93" />
              Agenda llena.
              <br data-id="element-94" />
              Desde hoy.
            </h1>
            <p className="font-montserrat text-lg md:text-xl text-gray-700 mb-8 max-w-2xl mx-auto lg:mx-0" data-id="element-95">
              El sistema N°1 para profesionales de estética en Argentina que
              quieren vender más, cobrar mejor y dejar de improvisar todo.
            </p>

            <div className="flex flex-wrap justify-center lg:justify-start gap-3 md:gap-6 mb-10 font-montserrat text-sm font-medium text-gray-800" data-id="element-96">
              <span className="flex items-center gap-1" data-id="element-97">📄 100% PDF</span>
              <span className="hidden md:inline" data-id="element-98">·</span>
              <span className="flex items-center gap-1" data-id="element-99">
                ⚡ Acceso en 5 min
              </span>
              <span className="hidden md:inline" data-id="element-100">·</span>
              <span className="flex items-center gap-1" data-id="element-101">
                💅 Todo el rubro estética
              </span>
              <span className="hidden md:inline" data-id="element-102">·</span>
              <span className="flex items-center gap-1" data-id="element-103">
                🛡️ Garantía 7 días
              </span>
            </div>

            <Button className="text-lg w-full md:w-auto md:px-12 py-5 mb-4 shadow-lg" data-id="element-104">
              → QUIERO MI MEGAKIT AHORA
            </Button>

            <div className="flex flex-wrap justify-center lg:justify-start gap-2 md:gap-4 font-montserrat text-xs text-gray-500" data-id="element-105">
              <span data-id="element-106">🛡️ Garantía 7 días</span>
              <span data-id="element-107">·</span>
              <span data-id="element-108">🔒 Pago seguro</span>
              <span data-id="element-109">·</span>
              <span data-id="element-110">⚡ Acceso inmediato</span>
              <span data-id="element-111">·</span>
              <span data-id="element-112">💳 Mercado Pago</span>
            </div>
          </div>

          <div className="flex-1 w-full max-w-xl" data-id="element-113">
            <img src="https://cdn.magicpatterns.com/uploads/mnGuQYbFAEaoZv92ddHmsp/mockup_megakit_mas_clientas.png" alt="Megakit Más Clientas Mockup" className="w-full h-auto drop-shadow-2xl" data-id="element-114" />
          </div>
        </div>
      </Section>

      {/* Stats Section */}
      <Section bg="base" className="py-8 md:py-12 border-t border-gray-200" data-id="element-115">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center divide-y md:divide-y-0 md:divide-x divide-gray-200" data-id="element-116">
          <div className="pt-4 md:pt-0" data-id="element-117">
            <p className="font-playfair text-4xl md:text-5xl font-bold text-dark mb-2" data-id="element-118">
              +3001
            </p>
            <p className="font-montserrat text-sm text-gray-600 uppercase tracking-wider" data-id="element-119">
              profesionales ya lo tienen
            </p>
          </div>
          <div className="pt-8 md:pt-0" data-id="element-120">
            <p className="font-playfair text-4xl md:text-5xl font-bold text-dark mb-2" data-id="element-121">
              06
            </p>
            <p className="font-montserrat text-sm text-gray-600 uppercase tracking-wider" data-id="element-122">
              tomos completos
            </p>
          </div>
          <div className="pt-8 md:pt-0" data-id="element-123">
            <p className="font-playfair text-4xl md:text-5xl font-bold text-dark mb-2" data-id="element-124">
              4.9/5
            </p>
            <p className="font-montserrat text-sm text-gray-600 uppercase tracking-wider" data-id="element-125">
              calificación ⭐
            </p>
          </div>
        </div>
      </Section>

      {/* Testimonials Hero */}
      <Section bg="base" className="pt-0 pb-16 md:pb-24" data-id="element-126">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-127">
          <Card className="bg-white" data-id="element-128">
            <div className="mb-4 text-brand" data-id="element-129">⭐⭐⭐⭐⭐</div>
            <p className="font-montserrat text-gray-700 italic mb-6" data-id="element-130">
              "La primera semana cerré 4 turnos que antes se me escapaban por
              WhatsApp. Los scripts son oro."
            </p>
            <p className="font-montserrat text-sm font-bold text-dark" data-id="element-131">
              — Valeria R. · 📍 Buenos Aires · Manicurista
            </p>
          </Card>
          <Card className="bg-white" data-id="element-132">
            <div className="mb-4 text-brand" data-id="element-133">⭐⭐⭐⭐⭐</div>
            <p className="font-montserrat text-gray-700 italic mb-6" data-id="element-134">
              "Por fin sé qué publicar todos los días. Dejé de subir cosas al
              azar esperando que alguien escriba."
            </p>
            <p className="font-montserrat text-sm font-bold text-dark" data-id="element-135">
              — Luciana C. · 📍 Córdoba · Lashista
            </p>
          </Card>
          <Card className="bg-white" data-id="element-136">
            <div className="mb-4 text-brand" data-id="element-137">⭐⭐⭐⭐⭐</div>
            <p className="font-montserrat text-gray-700 italic mb-6" data-id="element-138">
              "Subí mis precios el primer mes. Pensé que perdía clientas. No
              perdí ninguna. El Tomo 1 lo cambió todo."
            </p>
            <p className="font-montserrat text-sm font-bold text-dark" data-id="element-139">
              — Marcela S. · 📍 Rosario · Esteticista
            </p>
          </Card>
        </div>
      </Section>
    </>;
};